import type { PropsWithChildren } from 'react'

import { customMedia } from '@space-core/styles'

import clsx from 'clsx'
import styled from 'styled-components'

import ModuleCardBody from './body'
import ModuleCardFooter from './footer'
import ModuleCardHoverInformation from './hoverInformation'
import ModuleCardTags from './tags'
import ModuleCardThumbnail from './thumbnail'

export type ModuleCardProps = PropsWithChildren<{
  'data-test'?: string
  className?: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
}>

const Wrapper = styled.div`
  outline: none;
  border: none;
  text-align: unset;

  &:is(:focus, :active) {
    outline: none;
    border: none;
  }

  &:is(:focus, :hover) .module-card-body {
    ${customMedia.greaterThan('md')`
      z-index: 4;
      opacity: 1;
      left: -1.7rem;
      right: -1.7rem;
      bottom: -6rem;
      top: -6rem;
      transform: translateY(0);
      box-shadow: 0rem 0rem 0rem 0.25rem var(--gray-900);
      transition: all var(--timing) var(--easing) calc(var(--timing) / 3);
    `}
  }

  &:active .module-card-body {
    ${customMedia.greaterThan('md')`
        box-shadow: 0rem 0rem 0rem 0.125rem var(--gray-900);
    `}
  }

  &:is(:focus, :hover) .module-card-hover-information {
    ${customMedia.greaterThan('md')`
      transform: translateY(0);
      transition: transform 0.8s var(--easing) calc(var(--timing) / 2);
    `}
  }

  &:is(:focus, :hover) .module-card-footer {
    ${customMedia.greaterThan('md')`
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
    `}
  }
`

const ModuleCard = ({ onClick, children, className, 'data-test': dataTest }: ModuleCardProps) => {
  return (
    <Wrapper
      role='button' //TODO: add logic to be a link, a or button
      tabIndex={0}
      onClick={onClick}
      data-test={dataTest}
      className={clsx(
        '_position-relative _d-block _text-decoration-none _rounded-lg _border-0 _bg-transparent _cursor-pointer',
        className
      )}>
      {children}
    </Wrapper>
  )
}

ModuleCard.Thumbnail = ModuleCardThumbnail
ModuleCard.Tags = ModuleCardTags
ModuleCard.HoverInformation = ModuleCardHoverInformation
ModuleCard.Footer = ModuleCardFooter
ModuleCard.Body = ModuleCardBody

export default ModuleCard
